module.exports = globalThis["crateImports"]["react/jsx-runtime"];